/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Save_Preset_TitleInputs */



/**
* | output |
* | --- |
* | "Save current settings as a preset" |
*
* @param {Transcript_Export_Save_Preset_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_save_preset_title = /** @type {((inputs?: Transcript_Export_Save_Preset_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Save_Preset_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer les parametres actuels comme prereglage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktuelle Einstellungen als Voreinstellung speichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva le impostazioni correnti come predefinite")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохраните текущие настройки как предустановку.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar la configuración actual como un ajuste preestablecido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将当前设置保存为预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("現在の設定をプリセットとして保存する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तमान सेटिंग्स को प्रीसेट के रूप में सहेजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar as configurações atuais como uma predefinição")
	return /** @type {LocalizedString} */ ("Save current settings as a preset")
});